module.exports = __webpack_public_path__ + "static/media/jahjireh-logo.c8e00cb5.jpeg";